import { CommonAddinModule } from '@addins/common.module';
import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, Injector, NgModule } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { Addin, AddinModule } from '@techwan/ionic-core';

import { AppInfoSetupService } from './services/executables/app-info-menu/app-info-setup.service';
import { AppInfoViewComponent } from './views/app-info-view/app-info-view.component';

const directives = [];

const views = [AppInfoViewComponent];

const components = [...views];

const executables = [AppInfoSetupService];

const providers = [...executables];

@NgModule({
  declarations: [...components, ...directives],
  imports: [CommonModule, IonicModule, CommonAddinModule],
  exports: components,
  providers,
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
@Addin({
  name: 'AppInfo'
})
export class AppInfoModule extends AddinModule {
  constructor(injector: Injector) {
    super(injector, views, executables);
  }
}
